import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import DemosSection from "../components/DemosSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main className="relative" data-testid="home-page">
      <Header />
      <Hero />
      <ImpulsoCreativo />
      <About />
      <DemosSection />
      <ContactSection />
      <Footer />
    </main>
  );
}

const ImpulsoCreativo = () => (
  <section
    id="impulso"
    className="relative py-24 md:py-40 px-6 md:px-12 max-w-[1400px] mx-auto"
    data-testid="impulso-section"
  >
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
      <div className="md:col-span-1">
        <div className="text-xs tracking-[0.25em] uppercase text-[#F25C32] font-medium">
          Impulso<br />Creativo
        </div>
      </div>
      <div className="md:col-span-10 md:col-start-3">
        <p className="text-2xl sm:text-3xl md:text-4xl leading-[1.25] text-[#F5F5F0] font-light">
          La creatividad es lo que me mueve y lo que me ha permitido hacer todo
          lo que he querido en el <em className="text-[#F25C32] not-italic font-medium">mundo del arte escénico</em> y
          las <em className="text-[#F25C32] not-italic font-medium">comunicaciones</em>. Cada voz es una historia esperando ser contada.
        </p>
      </div>
    </div>
  </section>
);
